import * as React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import "../../css/pages/sidebar.scss";
import { NavLink } from "react-router-dom";
import { iContent } from "./ContentShow";
import { Skeleton } from "@mui/material";
import { withErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../helpers/ErrorFallback";
import { useGetGalleries } from "../../queries";

interface Props {
  category: string;
}

const Sidebar: React.FC<Props> = (Props) => {
  const NUMBER_OF_ITEMS = 4;

  const { data: relatedContents, isLoading: postsLoading } = useGetGalleries();

  return (
    <aside className="sideabar">
      <div className="sidebarContent">
        <div className="sidebarTopbar">آخرین های گالری تصاویر</div>
        <div className="sidebarContentShow">
          {postsLoading
            ? Array(NUMBER_OF_ITEMS)
                .fill(0)
                .map((_, index) => (
                  <div key={index} className="sidebarPanel">
                    <div className="contentContainerSide">
                      <Skeleton
                        variant="rectangular"
                        className="postTitleSide"
                        style={{ marginBottom: "10px" }}
                      />

                      <div className="contentDateContainerSide">
                        <div className="dateIconContentMain">
                          <AccessTimeIcon fontSize="small" />
                        </div>
                        <Skeleton
                          variant="rectangular"
                          className="contentDateMain"
                          width={50}
                        />
                      </div>
                    </div>
                    <div className="contentImageContainerSide">
                      <Skeleton
                        variant="rectangular"
                        className="contentImageContainerSide"
                        height="80%"
                        width="100%"
                      />
                    </div>
                  </div>
                ))
            : relatedContents
                ?.slice(0, NUMBER_OF_ITEMS)
                ?.map((value: iContent) => {
                  return (
                    <div key={value.id} className="sidebarPanel">
                      <div className="contentContainerSide">
                        <NavLink
                          className="navLink"
                          to={`/${Props.category}/${value.id}`}
                        >
                          <div className="postTitleSide">{value.title}</div>
                        </NavLink>
                        <div className="contentDateContainerSide">
                          <div className="dateIconContentMain">
                            <AccessTimeIcon fontSize="small" />
                          </div>
                          <div className="contentDateMain">{value.date}</div>
                        </div>
                      </div>
                      <div className="contentImageContainerSide">
                        <img
                          src={require(`../../${value.coverImage}`)}
                          alt="logo"
                        />
                      </div>
                    </div>
                  );
                })}
        </div>
      </div>
      <div className="relatedLinks">
        <div className="sidebarTopbar">لینک های مرتبط</div>
        <a href="http://www.iran-pta.ir/">انجمن فیزیوتراپی ایران</a>
        <a href="https://www.behzisti.ir/">سازمان بهزیستی کشور</a>
        <a href="https://www.behzisti.ir/service/province/golestan">
          سازمان بهزیستی استان گلستان
        </a>
      </div>
    </aside>
  );
};

export default withErrorBoundary(Sidebar, {
  FallbackComponent: ErrorFallback,
});
